// i18n area 'storage' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/storage.sk-SK.meta.json.
import type { enUS } from './storage'

export const skSK: typeof enUS = {
  storage: {
    pools: {
      title: 'Úložiská',
      createTitle: 'Vytvoriť úložisko',
      path: 'Cesta',
      pathHint: 'Absolútna cesta pod povoleným rootom (predvolené /var/lib/tvirt/pools/)',
      shared: 'Zdieľané úložisko',
      sharedChip: 'zdieľané',
      sharedVerifiedChip: 'zdieľané · overené',
      sharedVerifiedTooltip: 'Zdieľanie overené: krížové sondy potvrdzujú, že každý člen vidí dáta zapísané ostatnými.',
      sharedDisputedChip: 'zdieľané · NEOVERENÉ',
      sharedDisputedTooltip: 'Zdieľanie NEOVERENÉ',
      sharedDisputedPair: '{observer} nevidí dáta zapísané členom {writer}',
      sharedHint: 'Sieťové zdieľanie pripojené lokálne na rovnakej ceste na každom člene — prerekvizita live migrácie (deklaratívne).',
      sharedDanger: 'NEBEZPEČENSTVO — TVirt tomuto príznaku VERÍ: jeho zapnutím každý člen predpokladá, že na tejto ceste vidí TIE ISTÉ bajty. Na priečinku, ktorý NIE JE skutočným zdieľaním (NFS/CIFS/klastrový súborový systém), je výsledkom korupcia a strata dát pri prvej migrácii alebo prvom HA reštarte na inom uzle. Zapnite ho, len ak je cesta zdieľaním pripojeným identicky na každom uzle.',
      type: 'Typ',
      capacity: 'Kapacita',
      provisioned: 'Alokovaná',
      provisionedOvercommit: 'Potenciálny záväzok nad kapacitu: thin zväzky môžu narásť až na {n} GiB.',
      phase: { ready: 'Pripravený', degraded: 'Degradovaný', error: 'Chyba' },

      // Round #156 (dialog standard): il dialog dettagli COMPLETO — tab,
      // le righe di config per-driver e la superficie osservata.
      tabConfig: 'Konfigurácia',
      tabCapacity: 'Kapacita a stav',
      cardIdentity: 'Identita',
      cardPlacement: 'Umiestnenie',
      cardConnection: 'Pripojenie',
      usedReal: 'Skutočné obsadenie',
      capacityUnknown: 'Uzol ešte nenahlásil kapacitu tohto poolu — čísla si tu nevymýšľame',
      overcommitHint: 'Záväzok nad kapacitu: na thin pooloch legitímny, sledujte skutočné obsadenie',
      supportedContent: 'Podporovaný obsah',
      content: {
        disks: 'Disky',
        catalogFiles: 'Súbory katalógov',
        backups: 'Zálohy',
        appVolumes: 'Zväzky aplikácií'
      },
      defaultDiskFormat: 'Predvolený formát disku',
      reserveGiB: 'Rezervované voľné miesto (GiB)',
      available: 'Dostupné',
      diskCount: 'Disky',
      filesystem: 'Filesystem',
      observedAt: 'Pozorované',
      lostAtRow: 'Vyhlásené za stratené',
      sharedProbeRow: 'Overenie zdieľania',
      sharedProbeNodes: 'Sondované uzly',
      reachableFrom: 'Deklarovaná dosiahnuteľnosť',
      reachableFromHint: 'Uzly, z ktorých musí byť toto úložisko dosiahnuteľné. VM s diskami, ISO alebo metadátami tu sa nespustí ani nezmigruje na uzol mimo tohto zoznamu. Všetci členovia sú predvybraní: zúžte podľa potreby. Uzol, ktorý vstúpi do klastra neskôr, zostáva mimo, kým ho sem nepridáte.',
      reachableFromNone: 'nedeklarovaná',
      reachableFromTags: 'Dosiahnuteľnosť podľa značiek',
      reachableFromTagsHint: 'Selektor tag=hodnota (položky oddelené čiarkou, v AND): každý člen nesúci tieto značky je deklarovaný ako dosiahnuteľný — dynamicky: označenie uzla ho zaradí.',
      reachableFromTagsInvalid: 'Neplatný formát — použite tag=hodnota, oddelené čiarkou',
      reachableResolved: 'Rezolvované uzly: {nodes}',
      reachableDeclaredNotSeen: 'deklarované, ale nevidené sondou zdieľania na: {nodes}',
      reachableSeenNotDeclared: 'videné, ale nedeklarované (mimo perimetra) na: {nodes}',
      cephCluster: 'Spravovaný klaster Ceph',
      appGuardTitle: 'Úložisko používané aplikáciami',
      appEphemeralGuard: 'toto úložisko je klastrový efemérny pool aplikácií — najprv ho zmeňte na stránke Aplikácie, potom ho odstráňte.',
      appInUseGuard: 'žijú tu rooty/zväzky aplikácií: {apps} — najprv ich presuňte alebo odstráňte.',
      releaseRequiredTitle: 'Odstrániť „{name}“ a uvoľniť jeho obrazy?',
      releaseRequiredBatchTitle: 'Odstrániť vybrané storage a uvoľniť ich obrazy?',
      releaseRequiredBody: 'Uvoľnenie obrazov nezmaže ANI JEDEN bajt: zrušenie registrácie nechá namespace na disku, obrazy jednoducho prestanú byť materializované a každý odkaz scopov prežije ako claim — zaregistrujte pool znova a budú opäť adoptované.',
      releaseConfirm: 'Odstrániť a uvoľniť obrazy'
    },
    lost: {
      chip: 'Stratené',
      action: 'Vyhlásiť za stratené',
      confirmTitle: 'Vyhlásiť úložisko za stratené',
      confirmBody: 'Atestácia operátora na vlastné deklarované riziko: každá úloha vo fronte alebo prebiehajúca na tomto úložisku alebo jeho objektoch ZLYHÁ, odstraňovania budú len v registri (žiadna práca na súborovom systéme) a nová fyzická práca sa odmieta. Bajtov sa nikto nikdy nedotkne — ak sa zväzok vráti k životu, zaregistrujte ho znova a spustite sken na opätovnú adopciu všetkého.',
      confirmSubmit: 'Vyhlásiť za stratené',
      error: 'Atestácia bola odmietnutá'
    },
    findings: {
      action: 'Nájdené objekty',
      title: 'Nájdené objekty',
      empty: 'V namespace úložiska sa nenašiel žiadny objekt',
      loadError: 'Nájdené objekty sa nepodarilo načítať',
      actionError: 'Rozhodnutie bolo odmietnuté',
      colKind: 'Typ',
      colObject: 'Objekt',
      colConflict: 'Konflikt',
      namespaceNotice:
        'Tento adresár už bol inicializovaný iným úložiskom: identitná pečať bola prepísaná pečaťou tohto úložiska. Obsah NEBOL dotknutý — prejdi si nájdené objekty nižšie, naimportuj tie, ktoré potrebuješ, a potom toto upozornenie zavri.',
      kind: {
        disk: 'Disk',
        catalogFile: 'Súbor katalógu',
        vmMetadata: 'Metadáta VM',
        namespace: 'Namespace',
        foreign: 'Cudzí',
        volumeGroup: 'Skupina zväzkov'
      },
      vgAdopt: {
        action: 'Adoptovať skupinu zväzkov',
        title: 'Adoptovať skupinu zväzkov',
        intro:
          'Toto zariadenie už nesie skupinu zväzkov s názvom TVirt, ale jej pečať nemenuje žiadne tu registrované storage. Môže to byť to, čo na LUN zanechalo predchádzajúce storage TOHTO clustra — alebo to, čo zanechal INÝ cluster TVirt na LUN, ktorá zmenila majiteľa: odtiaľto vyzerajú oba prípady rovnako, a preto nikto nerozhoduje za vás.',
        irreversible: 'Pozrite sa na zariadenie, pečať a názov, kým budete pokračovať: adopciu nemožno vziať späť.',
        device: 'Zariadenie',
        seal: 'Pečať',
        sealNone: 'žiadna (bez tagu tvirt.storageId)',
        renameTo: 'Bude premenovaná na',
        renameNone: 'Bez premenovania: názov už je ten, ktorý toto storage odvodzuje',
        volumesNote:
          'Obsiahnuté zväzky sa týmto gestom NEadoptujú: ďalší sken ich ponúkne jeden po druhom, ako bežné nájdené objekty.'
      },
      conflictChip: 'ID už existuje',
      dismissedChip: 'Ignorovaný',
      adopt: 'Adoptovať',
      adoptFileTitle: 'Importovať do katalógu',
      adoptFileHint: 'Súbory existujú len vnútri katalógov: vyberte cieľový katalóg pre nájdený súbor.',
      purge: 'Odstrániť z disku',
      dismiss: 'Ignorovať',
      purgeConfirmTitle: 'Odstrániť z disku',
      purgeConfirmBody: 'Nájdené bajty {id} budú odstránené z úložiska. Operácia je nevratná.',
      taskStarted: 'Spustené — pokračuje ako úloha na pozadí',
      scan: 'Skenovať úložisko',
      scanStarted: 'Sken spustený…',
      scanDone: 'Sken dokončený — nájdené objekty sú aktualizované'
    },
    reinit: {
      action: 'Skúsiť inicializáciu znova'
    },
    wizard: {
      addButton: 'Pridať',
      title: 'Pridať úložisko',
      back: 'Späť',
      continue: 'Pokračovať',
      selectHint: 'Vyberte protokol a uvidíte, ako ho TVirt používa.',
      roadmap: 'Roadmap',
      server: 'Server',
      export: 'Exportovaná cesta',
      share: 'Zdieľanie',
      username: 'Meno používateľa',
      password: 'Heslo',
      passwordHint: 'Len na zápis: použije sa pri pripájaní (mount), už sa nikdy nezobrazí.',
      credential: 'Poverenie',
      credentialManual: 'Zadať ručne',
      credentialHint: 'Položka keystore typu username a password — alternatíva k ich zadaniu tu.',
      credentialEmpty: 'V keystore nie je žiadne poverenie typu username a password — vytvorte ho v Systém → Poverenia, alebo zadajte účet nižšie.',
      options: 'Možnosti pripojenia',
      optionsHint: 'Oddelené čiarkou, odovzdané do mount -o tak, ako sú.',
      portal: 'Portal',
      portalHint: 'host[:port] — predvolený port je 3260.',
      target: 'Target IQN',
      targetHint: 'Názov iSCSI targetu, začína sa iqn.',
      lun: 'LUN',
      wholeLunRow: 'Na diskoch: tento storage menuje iba target',
      wholeLunHint: 'Tento storage menuje iba target: jeho LUNy sa stávajú diskami jeden po druhom (Vytvoriť disk → prevziať celý LUN), na target sa nič nezapisuje.',
      lunHint: 'Číslo LUN na targete — pri pochybnostiach 0.',
      chapCredential: 'Poverenie (CHAP)',
      chapCredentialHint: 'Položka keystore typu CHAP (iSCSI) použitá pri logine — tajomstvo nikdy necestuje s úložiskom.',
      chapNone: 'Žiadna autentifikácia',
      chapEmpty: 'V keystore nie je žiadne poverenie typu CHAP (iSCSI) — vytvorte ho v Systém → Poverenia. Bez neho zostáva login neautentifikovaný.',
      address: 'Adresa',
      addressHint: 'Host alebo IP NVMe/TCP targetu (traddr).',
      port: 'Port',
      portHint: 'TCP port targetu — 4420, ak zostane prázdne.',
      targetNqn: 'Target NQN',
      targetNqnHint: 'NQN subsystému na targete, začína sa nqn.',
      nsid: 'NSID',
      nsidHint: 'Namespace ID vnútri subsystému — pri pochybnostiach 1.',
      dhchapCredential: 'Poverenie (DH-HMAC-CHAP)',
      dhchapCredentialHint: 'Položka keystore typu DH-HMAC-CHAP (NVMe) použitá pri pripájaní — tajomstvo nikdy necestuje s úložiskom.',
      dhchapNone: 'Žiadna autentifikácia',
      dhchapEmpty: 'V keystore nie je žiadne poverenie typu DH-HMAC-CHAP (NVMe) — vytvorte ho v Systém → Poverenia. Bez neho zostáva pripojenie neautentifikované.',
      monitors: 'Monitory',
      monitorsHint: 'Endpointy monitorov Ceph, host[:port], oddelené čiarkou alebo novým riadkom — predvolený port 6789.',
      pool: 'Pool',
      poolHint: 'RBD pool na konzumáciu — jeden RBD obraz na disk.',
      fs: 'Filesystem',
      fsHint: 'Názov filesystemu CephFS (mds_namespace pri mounte).',
      fsPath: 'Cesta vnútri filesystemu',
      fsPathHint: 'Absolútna cesta vnútri filesystemu, ktorú úložisko pripája — pri pochybnostiach /.',
      cephxCredential: 'Poverenie (cephx)',
      cephxCredentialHint: 'Položka keystore typu cephx: username = meno klienta (client.…), secret = kľúč v base64. Povinná.',
      cephxNone: 'V keystore nie je žiadne poverenie cephx — vytvorte ho (typ: cephx) v Systém → Poverenia, alebo nechajte spravovaný klaster Ceph, aby ho vyrazil cez „Navrhnúť ako úložisko“.',
      sharedByNature: 'Sieťové úložiská sú zdieľané zo svojej podstaty: každý člen ich pripája na rovnakej ceste spravovanej platformou TVirt.',
      error: 'Úložisko bolo odmietnuté',
      category: {
        nas: 'NAS',
        san: 'SAN',
        ceph: 'Ceph',
        other: 'Iné',
        legacy: 'Legacy'
      },
      legacyHint: 'Plne podporované — len by sme si ich nevybrali pre novú inštaláciu.',
      proto: {
        // La riga `usage` (Luca 2026-07-24) dice come TVirt usa il protocollo —
        // in primis i contenuti ammessi: dir/nfs/cifs ospitano dischi E immagini
        // ISO/disco e template, i driver a blocchi (iscsi/nvme-tcp/rbd) SOLO
        // dischi.
        dir: {
          name: 'Lokálny priečinok',
          desc: 'Adresár na uzle: jednoduché a rýchle. Je LOKÁLNY pre uzol, pokiaľ cesta nie je skutočným zdieľaním — označiť ho ako zdieľaný, keď nie je, stojí dáta.',
          usage: 'TVirt v ňom uchováva disky VM, obrazy ISO/disku a šablóny.'
        },
        nfs: {
          name: 'NFS',
          desc: 'NFS export pripojený klastrom — zdieľaný zo svojej podstaty.',
          usage: 'Hostí disky VM, obrazy ISO/disku a šablóny.'
        },
        cifs: {
          name: 'CIFS/SMB',
          desc: 'Zdieľanie Windows/Samba pripojené klastrom — zdieľané zo svojej podstaty.',
          usage: 'Hostí disky VM, obrazy ISO/disku a šablóny.'
        },
        sftp: {
          name: 'SFTP',
          desc: 'Vzdialený súborový systém cez SSH — bez potreby NAS exportu.',
          usage: 'V roadmape.'
        },
        iscsi: {
          name: 'iSCSI',
          desc: 'Blokové LUN cez IP so zdieľaným LVM navrchu.',
          usage: 'Len disky — jeden thin zväzok na disk; nehostí obrazy ISO ani šablóny.'
        },
        rbd: {
          name: 'Ceph RBD',
          desc: 'Blokové zariadenia distribuované na klastri Ceph.',
          usage: 'Len disky — jeden RBD obraz na disk, otváraný natívne cez QEMU; nehostí obrazy ISO.'
        },
        cephfs: {
          name: 'CephFS',
          desc: 'Distribuovaný súborový systém Ceph, pripájaný kernelom na klastri — shared by nature.',
          usage: 'Hostí disky VM, obrazy ISO/disku a šablóny — rodina dir na súborovom systéme Ceph (poverenie cephx povinné).'
        },
        fc: { name: 'SCSI/FC', desc: 'SCSI LUN na fabricu FibreChannel — klasická FC SAN.' },
        fcoe: { name: 'SCSI/FCoE', desc: 'To isté SCSI na FibreChannel, s FC rámcami zapuzdrenými v Ethernete.' },

        // Vivo dal round #132 — la chiave è il nome del driver del contract,
        // così il chip della lista storage risolve la stessa voce.
        'iscsi-lun': {
          name: 'iSCSI (celé LUNy)',
          desc: 'iSCSI target ako nosič celých LUNov: každý disk JE LUN, odovzdaný hosťovi surový — bez LVM medzitým.',
          usage: 'Iba disky — jeden celý LUN na disk, prevzatý tak, ako je; SAN domov diskov so zdieľaným zápisom.'
        },
        'nvme-tcp-lun': {
          name: 'NVMe/TCP (celé namespace)',
          desc: 'NVMe subsystém ako nosič celých namespace: každý disk JE namespace, odovzdaný hosťovi surový.',
          usage: 'Iba disky — jeden celý namespace na disk, prevzatý tak, ako je; zdieľaný zápis áno, SCSI persistent reservations nie.'
        },
        'nvme-tcp': {
          name: 'NVMe/TCP',
          desc: 'Vzdialené NVMe — žiadne SCSI v ceste — na čistom TCP, so zdieľaným LVM navrchu.',
          usage: 'Len disky — jeden thin zväzok na disk; nehostí obrazy ISO ani šablóny.'
        },
        nvmefc: { name: 'NVMe/FC', desc: 'Vzdialené NVMe na fabricu FibreChannel.' },
        nvmefcoe: { name: 'NVMe/FCoE', desc: 'NVMe na FibreChannel fabricu, ktorý FCoE prenáša v Ethernete — vrstvy FCoE a NVMe/FC naskladané na sebe.' },
        iser: { name: 'iSCSI/RDMA (iSER)', desc: 'iSCSI s dátovou cestou presunutou na RDMA — akýkoľvek fabric (InfiniBand, iWARP, RoCE). Prekonané cez NVMe/RDMA, stále prítomné v diskových poliach a v ESXi.' },
        srp: { name: 'SCSI/RDMA (SRP)', desc: 'Natívne SCSI na RDMA, éra pred iSER: InfiniBand (s fabric discovery) a RoCE — prežíva v starších HPC úložiskách.' },
        nvmerdma: { name: 'NVMe/RDMA', desc: 'Vzdialené NVMe na akomkoľvek RDMA fabricu — InfiniBand, iWARP, RoCE v1 a v2: jedna konfigurácia, ktorý fabric má, povie uzol.' },
        s3: { name: 'S3', desc: 'Objektové úložisko kompatibilné s S3 — obrazy a zálohy.' }
      }
    },
    catalogs: {
      title: 'Katalógy',
      createTitle: 'Vytvoriť katalóg',
      editTitle: 'Upraviť katalóg',
      docTitle: 'Katalóg',
      notFound: 'Tento katalóg (už?) neexistuje',
      scopeHint: 'Kto číta tento scope, vidí (a môže používať) každý súbor katalógu',
      files: 'Súbory',
      noFiles: 'Žiadne súbory',
      count: {
        iso: 'ISO',
        ctRootfs: 'Tpl CT',
        vmTemplate: 'Tpl VM',
        ociImage: 'OCI',
        firmwareOvmf: 'Firmvér'
      },

      // Il catalogo di sistema (round #126): la casa degli oggetti integrati
      // della piattaforma — leggibile da tutti, scrivibile da nessuno.
      systemChip: 'systémový',
      systemTooltip: 'Systémový katalóg: hostí integrované objekty platformy a nedá sa upravovať'
    },

    // File di catalogo (round K1, inventory v2e/v2g): il catalogo è la casa
    // degli artefatti file del cluster — una lista, titoli per kind.
    catalogFiles: {
      catalog: 'Katalóg',
      kindLabel: 'Typ',
      physicalSize: 'Fyzická veľkosť',
      virtualSize: 'Virtuálna veľkosť',

      // Round K3 (#64) + K4 (#65, ova/ovf con la mappatura boot-survival):
      // materializza un file vm-template come VM Template dell'inventario.
      importTemplateAction: 'Importovať ako VM Template',
      importTemplateLegacy: 'Žiadny deklarovaný formát — použiteľný ako seed pre disky, neimportovateľný',
      importTemplateTitle: 'Importovať ako VM Template',
      importTemplateSubmit: 'Importovať',
      importTemplateError: 'Import sa nepodaril',
      importTemplateHint: 'Balík .tvtpl sa stane VM Template: zmrazený hardvér z manifestu plus jeden disk na entry archívu, každý overený proti svojmu checksumu. NIC a mechaniky CD/DVD nie sú súčasťou archívu — pridajte ich po importe.',
      importTemplateQcow2Hint: 'Holý qcow2 sa stane šablónou s JEDNÝM diskom a deklarovaným predvoleným hardvérom: profil linux, UEFI, 2 vCPU, 2048 MiB, boot z jeho jediného disku. Opravte pri nasadení.',
      importTemplateName: 'Názov šablóny',
      importTemplateNameHint: 'Prázdne = {name} (-import-<n>, ak je obsadené)',
      importTemplateStorage: 'Úložisko pre disky',
      importTemplateMetadataStorage: 'Úložisko metadát',
      importTemplateMetadataHint: 'Blokové úložisko nehostí metadáta VM (firmvér, varstore) — vyberte niektoré dir/nfs/cifs.',
      importTemplateStarted: 'Import spustený — šablóna sa objaví na karte Šablóny po skončení úlohy.',

      // Etichette parlanti al singolare (#86): findings e censimento dicono
      // COSA è il file — il generico 'File di catalogo' resta solo fallback.
      kind: {
        iso: 'Obraz ISO',
        'ct-rootfs': 'Rootfs CT',
        'vm-template': 'Šablóna VM',
        'oci-image': 'Obraz OCI',
        'firmware-ovmf': 'Firmvér OVMF'
      },
      title: {
        iso: 'Obrazy ISO',
        'ct-rootfs': 'Šablóny CT',
        'vm-template': 'Šablóny VM',
        'oci-image': 'Obrazy OCI',
        'firmware-ovmf': 'Firmvér OVMF'
      },
      createTitle: {
        iso: 'Pridať obraz ISO',
        'ct-rootfs': 'Registrovať šablónu CT',
        'vm-template': 'Pridať šablónu VM',
        'oci-image': 'Pridať obraz OCI',
        'firmware-ovmf': 'Pridať firmvér OVMF'
      },
      formatHint: 'Odvodené z prípony zvoleného súboru — opravte, ak hádal zle',
      tarballHint: 'Rootfs tarball v štandardnom formáte LXC (.tar.gz / .tar.xz / .tar.zst / .tar.bz2, alebo obyčajný .tar)',
      ociArchiveHint: 'Tarball docker-archive / oci-archive (.tar alebo .tar.gz), napríklad z docker save',
      uploadResumeHint: 'Nahrávanie prerušené — súbor čaká na upload: odošlite znova ten istý súbor, aby pokračovalo',
      moveTitle: 'Presunúť súbor',
      moveHint: 'Dva nezávislé rozmery: Katalóg presunie odkaz (rovnaké id, žiadny bajt sa nepohne, scope sa stane scopom cieľového katalógu); Úložisko presunie dáta — každá prepojená kópia ho nasleduje, odmietnuté, kým sa súbor používa. Zvolené spolu: najprv katalóg, potom úložisko.',
      moveCatalog: 'Cieľový katalóg',
      moveCatalogHint: 'Domov mení iba odkaz: VM, ktoré má súbor pripojený, musí cieľový katalóg vidieť',
      keepCurrent: 'Nemeniť',
      rehomed: 'Odkaz presunutý do zvoleného katalógu',
      copyAction: 'Kopírovať do katalógu…',
      copyTitle: 'Kopírovať do katalógu',
      copyLinkHint: 'Kópia je nové prepojenie na tie isté dáta — na úložisku sa nič neduplikuje.',
      copyCatalog: 'Cieľový katalóg',
      copyCatalogHint: 'Kópia je spôsob, akým súbor cestuje medzi katalógmi',
      sameCatalog: 'Rovnaký ako zdroj',
      sharedObjectHint: 'Dáta tohto súboru zdieľajú prepojené kópie: {count}',
      deleteLastLink: 'Toto je POSLEDNÉ prepojenie na tento obsah: odstránia sa aj dáta z úložiska.',
      deleteLinkOnly: 'Odstráni sa len toto prepojenie — dáta zostávajú, stále dosiahnuteľné z ostatných prepojených kópií ({count}).',
      noCatalog: 'Neexistuje žiadny katalóg — vytvorte ho',
      inlineCatalogName: 'Názov katalógu',

      // File integrati nella piattaforma (round #126): storage null — si
      // leggono e si clonano, mai move/delete/rename.
      embeddedChip: 'integrovaný',
      embeddedStorage: 'Integrovaný v platforme',
      embeddedNoMove: 'Integrovaný súbor platformy: nežije na žiadnom úložisku — namiesto toho ho naklonujte',
      embeddedCopyHint: 'Klon materializuje integrované bajty na skutočnom úložisku: vyberte cieľové úložisko a katalóg — kópia je obyčajný súbor',
      sourceEmbedded: 'Integrovaný v platforme',
      nodesRow: 'Prítomnosť na uzloch',
      nodesSummary: '{present} z {total} uzlov ho má',
      nodePresent: 'prítomný',
      nodeMissing: 'chýba',
      nodeUnknown: 'zatiaľ nenahlásené',
      nodesHint: 'Asset leží na disku každého uzla (balík trantor-tvirt-assets): uzol, ktorý ho nemá, nemôže definovať VM s týmto firmvérom ani poskytovať Guest Tools. Rôzne verzie medzi uzlami sú počas postupnej aktualizácie normálne.',

      // Download (round #108): i byte viaggiano col loro permesso dedicato.
      downloadAction: 'Stiahnuť',
      downloadNotReady: 'Obsah ešte nie je pripravený — sťahovanie vyžaduje súbor v stave ready',
      downloadDenied: 'Vaša rola nezahŕňa catalog.download — stiahnuť bajty je právo oddelené od používania súboru',

      // Round #156 (dialog standard): le righe di lettura mancanti del dialog
      // dettagli — i fatti dell'oggetto condiviso, il checksum dichiarato, gli
      // utilizzatori.
      objectRow: 'Objekt úložiska',
      objectLinksRow: 'Prepojené kópie',
      declaredChecksum: 'Deklarovaný SHA-256',
      usedByRow: 'Používa ho',
      usedByVms: 'VM',
      usedByDisks: 'Disky',
      transferRow: 'Prenos',
      storageLockHint: 'Mení sa len akciou Presunúť'
    },

    // Il censimento per-storage (round K1, inventory v2b #2): sola lettura,
    // ogni oggetto si gestisce dalla sua sezione.
    objects: {
      action: 'Prehľadávať obsah',
      title: 'Obsah úložiska',
      hint: 'Súpis len na čítanie toho, čo žije na tomto úložisku — každý objekt sa spravuje vo svojej sekcii.',
      empty: 'Na tomto úložisku nie je registrovaný žiadny objekt',
      loadError: 'Obsah sa nepodarilo načítať',
      colDetail: 'Detail',
      manage: 'Spravovať v jeho sekcii',
      kind: {
        disk: 'Disk',
        catalogFile: 'Súbor katalógu',
        ociBlob: 'Blob OCI',
        checkpoint: 'Checkpoint',
        vmMetadata: 'Metadáta VM',
        appRoot: 'Root aplikácie',
        appVolume: 'Zväzok aplikácie'
      }
    },
    inventory: {
      tabCatalogs: 'Katalógy',
      storage: 'Úložisko',
      sizeGib: 'Veľkosť (GiB)',
      format: 'Formát',
      size: 'Veľkosť',
      sourceType: 'Zdroj',
      sourceFile: 'Nahranie súboru',
      sourceUrl: 'Stiahnutie z URL',
      file: 'Súbor',
      url: 'URL',
      checksum: 'Checksum SHA-256',
      checksumHint: 'Povinné: stiahnutie sa overuje proti tomuto SHA-256',
      verifyChecksum: 'Overiť checksum',
      checksumOffHint: 'Stiahnutie bude prijaté bez overenia — vypočítaný SHA-256 sa aj tak zaznamená',
      uploading: 'Nahrávanie…',
      move: {
        action: 'Presunúť',
        diskTitle: 'Presunúť disk',
        target: 'Cieľové úložisko',
        diskHint: 'Disk si zachováva identitu: bajty cestujú do zvoleného úložiska. VM, ktorá ho používa, musí byť vypnutá; pri existujúcich snímkach iSCSI strana presun odmieta.',
        noTargets: 'Žiadne kompatibilné cieľové úložisko',
        submit: 'Presunúť',
        error: 'Presun bol odmietnutý'
      },
      clone: {
        action: 'Klonovať',
        title: 'Klonovať disk',
        name: 'Názov kópie',
        storage: 'Cieľové úložisko',
        sameStorage: 'Rovnaké ako zdroj',
        linked: 'Linked klon',
        linkedHint: 'Okamžitý qcow2 overlay zreťazený so zdrojovým diskom (len qcow2 zdroje). Predvolená je úplná kópia.',
        linkedCrossHint: 'Linked klon zostáva na úložisku zdroja: na jeho povolenie vyberte „Rovnaké ako zdroj“.',
        submit: 'Klonovať',
        error: 'Klonovanie bolo odmietnuté'
      },
      copy: {
        action: 'Kopírovať',
        name: 'Názov kópie',
        storage: 'Cieľové úložisko',
        sameStorage: 'Rovnaké ako zdroj',
        submit: 'Kopírovať',
        error: 'Kopírovanie bolo odmietnuté'
      },
      taskStarted: 'Spustené — pokračuje ako úloha na pozadí',
      cephObjects: 'Prejsť na detail objektu v Ceph',
      phase: {
        ready: 'Pripravený',
        creating: 'Vytvára sa',
        'awaiting-upload': 'Čaká na nahranie',
        downloading: 'Sťahuje sa',
        verifying: 'Overuje sa',
        deleting: 'Odstraňuje sa',
        error: 'Chyba',
        'in-use': 'V použití'
      }
    }
  }
}
